import script from "./InstallPwaButton.vue?vue&type=script&setup=true&lang=js"
export * from "./InstallPwaButton.vue?vue&type=script&setup=true&lang=js"

import "./InstallPwaButton.vue?vue&type=style&index=0&id=64a3b950&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64a3b950"]])

export default __exports__